<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:20px">
              <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Regions</v-btn>
              <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Cities</v-btn>
              <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Service Location</v-btn>
              <v-btn class="primary" v-on:click="sho4()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Third Party</v-btn>
              <v-btn class="primary" v-on:click="sho5()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Accounted Customers</v-btn>
              <v-btn class="primary" v-on:click="sho6()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Employees</v-btn>
              <v-btn class="primary" v-on:click="sho7()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">New Truck</v-btn>
              <v-btn v-on:click="sho8() && activate(1)" :class="{ active_el: active_el == 1 }" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px;color: #ffffff">Pickup</v-btn>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12>
          <v-flex xs3></v-flex>
          <v-flex xs6>
            <v-card style="margin-top: 20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Pick - Up Request</h3>
                <!--<v-btn flat class="primary" style="margin-left:350px;margin-bottom: 10px;margin-top:-10px" v-on:click="back()">Back</v-btn>-->
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:40px">
                      <label>Name</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-flex d-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs5 style="">
                            <v-text-field
                              v-model="firstname"
                              label="First Name"
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 style="margin-left:20px">
                            <v-text-field
                              v-model="lastname"
                              label="Last Name"
                              outline
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:40px">
                      <label>Email</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-text-field
                        v-model="email"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Contact Number</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <vue-tel-input v-model="phone" outline style="height:55px;margin-bottom:30px;border-color: grey;border-width: 2px"></vue-tel-input>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Address</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-text-field
                        v-model="address1"
                        label="Address Line 1"
                        outline
                      ></v-text-field>
                      <v-text-field
                        v-model="address2"
                        label="Address Line 2"
                        outline
                      ></v-text-field>
                      <v-layout row wrap>
                        <v-flex d-flex xs12>
                          <v-flex xs5 style="margin-top:0px">
                            <v-text-field
                              v-model="city"
                              label="City/District"
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs7 style="margin-top:0px;margin-left:10px">
                            <v-text-field
                              v-model="state"
                              label="State/Province"
                              outline
                            ></v-text-field>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex d-flex xs12>
                          <v-flex xs5 style="margin-top:0px">
                            <v-text-field
                              v-model="pincode"
                              label="Pin Code"
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs7 style="margin-top:0px;margin-left:10px">
                            <v-overflow-btn
                              :items="country_list"
                              label="Country"
                              target="#dropdown-example"
                              style=""
                              outline
                            ></v-overflow-btn>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>City</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-overflow-btn
                        :items="cityname"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Pickup Date</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        style="margin-left:20px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Select Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <h4 style="margin-top:20px;margin-bottom:20px">Commodity Details</h4>
                    <v-data-table
                      :headers="headers"
                      :items="desserts"
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.commodity}}</td>
                        <td class="text-xs-left">{{ props.item.weigth}}</td>
                      </template>
                    </v-data-table>
                    <v-dialog
                                    v-model="dialog"
                                    width="800"
                                  >
                                    <v-btn class="primary" style="margin-top: 20px;margin-bottom:20px;margin-left: 200px" slot="activator">+ Add New</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Add Commodity
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Commodity</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Approx. Weight in KG</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Save
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Nearest Service Locations</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-overflow-btn
                        :items="servicelocation"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import VueTelInput from 'vue-tel-input'
export default {
  components: {
    VueTelInput
  },
  data () {
    return {
      active_el: 1,
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      pincode: '',
      country_list: ['India', 'USA', 'China'],
      cityname: ['Mumbai', 'Kolkata', 'Pune', 'Nagpur'],
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Commodity', value: 'commodity' },
        { text: 'Approx. Weight (KG)', value: 'weight' }
      ],
      desserts: [],
      servicelocation: ['Mumbai', 'Kolkata', 'Pune', 'Nagpur'],
      dialog: false
    }
  },
  methods: {
    submit () {
    },
    addnew () {
    },
    sho1 () {
      this.$router.push('/Truckingaddregions')
    },
    sho2 () {
      this.$router.push('/Truckingaddcities')
    },
    sho3 () {
      this.$router.push('/Truckingservicelocation')
    },
    sho4 () {
      this.$router.push('/Truckingthirdpartytransporters')
    },
    sho5 () {
      this.$router.push('/Truckingaccountedcustomers')
    },
    sho6 () {
      this.$router.push('/Truckingemployees')
    },
    sho7 () {
      this.$router.push('/Truckingaddnewtruck')
    },
    sho8 () {
      this.$router.push('/Truckingpickuprequest')
    },
    activate: function (el) {
      this.active_el = el
    }
  }
}
</script>
<style>
 .active_el{
    background-color: #00C853
  }
</style>



// WEBPACK FOOTER //
// src/components/Truckingpickuprequest.vue